import React from 'react';
import SubFormVacation from './SubFormVacation';
import SubFormApproval from './SubFormApproval';

function SubFormRouter({ subFormCode, formData, setFormData, mode = 'write', docTitle = '' }) {
  switch (subFormCode) {
    case 'D001_sub':
      return (
        <SubFormApproval formData={formData} setFormData={setFormData} mode={mode} docTitle={docTitle} />
      );
    case 'D002_sub':
      return (
        <SubFormVacation formData={formData} setFormData={setFormData} mode={mode} />
      );

    default:
      return null;
  }
}

export default SubFormRouter;